import { getData } from '@/utils/http';
import config from '@/config';
export default {
  namespaced: true,
  state: {
    name: '',
    status: '',
    tableLoading: true,
    addLoading: false,
    tableList: [],
    tableData: [],
    type: '',
    pageIndex: 1,
    total: 0, 
  },
  mutations: {
    CHANGE_TABLE_LOADING(state, tableLoading) {
      state.tableLoading = tableLoading;
    },
    CHANGE_ADD_LOADING(state, addLoading) {
      state.addLoading = addLoading;
    },
    CHANGE_TABLE_DATA(state, data) {
      state.tableList = data.rows;
      state.total = data.total;
    },

    CHANGE_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state[changeData['changeKey']] = [changeData['data']];
      } else {
        state[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_TABLE_INDEX(state, value) {
      state.pageIndex = value;
    },
  },
  actions: {
    //获取列表
    getList({ commit, state }) {
      const queryParams = config.jsonToQueryParams({
        page: state.pageIndex,
        size: config.pageSize,
        name: state.name,
        status:state.status,
        type:2
      });
      return new Promise((resolve) => {
        getData(`platform/auth/apply/page?${queryParams}`).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_TABLE_DATA', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },

    //写入查询条件
    setSearchData({ commit }, changeData) {
      commit('CHANGE_SEARCH_COLL', changeData);
    },
    //修改分页
    setPageIndex({ commit }, value) {
      commit('CHANGE_TABLE_INDEX', value);
    },
    //修改添加loading
    changeAddLoading({ commit }, value) {
      commit('CHANGE_ADD_LOADING', value);
    },
    //修改添加loading
    changeListLoading({ commit }, value) {
      commit('CHANGE_TABLE_LOADING', value);
    },
  },
};
